module.exports = __webpack_public_path__ + "img/room-creative-award_in.a13d4798.png";